import { createContext, useContext } from "react";

import type { TestEmailInput } from "@/lib/gql/__generated__/graphql";

import type { AccommodationHotelPolicyI18nFormModel, QueryData } from "../../model/type";

export type AccommodationHotelPolicyI18nFormModelContextType = {
	viewModel: AccommodationHotelPolicyI18nFormModel["ViewModel"];
	onSetViewModel: <K extends keyof AccommodationHotelPolicyI18nFormModel["ViewModel"]>(
		values: { key: K; value: AccommodationHotelPolicyI18nFormModel["ViewModel"][K] }[],
	) => void;
	queryData: QueryData;

	onUpdate: () => void;

	testEmailSender: {
		onSendTestEmailReservationCin: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailReservationCanceled: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailReservationCreated: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailReservationUpdated: (input: TestEmailInput) => Promise<void>;

		onSendTestEmailRequestReservationConfirmed: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailRequestReservationDeclined: (input: TestEmailInput) => Promise<void>;
		onSendTestEmailRequestReservationRequested: (input: TestEmailInput) => Promise<void>;
	};
};

export const AccommodationHotelPolicyI18nFormModelContext =
	createContext<AccommodationHotelPolicyI18nFormModelContextType | null>(null);

export const useAccommodationHotelPolicyI18nFormModelContext = (): AccommodationHotelPolicyI18nFormModelContextType => {
	const hotelPolicyI18nStore = useContext(AccommodationHotelPolicyI18nFormModelContext);

	if (!hotelPolicyI18nStore) {
		throw new Error("hotelPolicyI18nStore is null");
	}

	return hotelPolicyI18nStore;
};
